export const supportedLocales = ["en", "ja", "vi", "th"] as const

export type SupportedLocale = (typeof supportedLocales)[number]

export const defaultLocale: SupportedLocale = "en"
export const sharedLocaleCookieName = "avacus_locale"
export const legacyLocaleCookieNames = [
  "avacus-gas-sponsor-lang",
  "avacus-services-language",
  "i18next",
] as const
export const localeCookieNames = [
  sharedLocaleCookieName,
  ...legacyLocaleCookieNames,
] as const

export function normalizeLocale(
  locale: string | null | undefined
): SupportedLocale | null {
  const normalizedLocale = locale?.split("-")[0]?.toLowerCase()
  if (supportedLocales.includes(normalizedLocale as SupportedLocale)) {
    return normalizedLocale as SupportedLocale
  }
  return null
}

export function getLocaleCookieDomain(hostname: string | null | undefined) {
  const normalizedHostname = (hostname ?? "").split(":")[0]?.toLowerCase() ?? ""
  return normalizedHostname === "avacus.cc" ||
    normalizedHostname.endsWith(".avacus.cc")
    ? ".avacus.cc"
    : undefined
}

export function resolveLocale({
  urlLocale,
  cookieLocales = [],
  browserLocale,
  fallback = defaultLocale,
}: {
  urlLocale?: string | null
  cookieLocales?: Array<string | null | undefined>
  browserLocale?: string | null
  fallback?: SupportedLocale
}): SupportedLocale {
  return (
    normalizeLocale(urlLocale) ??
    cookieLocales.map(normalizeLocale).find(Boolean) ??
    normalizeLocale(browserLocale) ??
    fallback
  )
}
